import React, {useEffect, useState} from "react";
import {useSubheader} from "../../_metronic/layout";
import {useTranslation} from "react-i18next";
import makeRequest from "../api/makeRequest";
import {Checkbox, Paper, Table, TableBody, TableCell, TablePagination, TableRow} from "@material-ui/core";
import EnhancedTableHead from "../components/EnhancedTableHead";
import moment from "moment-jalaali";

export const SessionsPage = () => {
	const { t } = useTranslation('common');
	const headRows = [
		{id: "id", disablePadding: true, label: t('Id')},
		{id: "user", disablePadding: false, label: t('User')},
		{id: "room", disablePadding: false, label: t('RoomName')},
		{id: "ttl", disablePadding: false, label: t('Validity')},
		{id: "expireAt", disablePadding: false, label: t('Expiration')},
		{id: "active", disablePadding: false, label: t('ActiveInactive')}
	];
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('Sessions'));

	const [selected, setSelected] = React.useState([]);
	const [orderBy, setOrderBy] = React.useState("id");
	const [order, setOrder] = React.useState("desc");
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const [totalDocs, setTotalDocs] = React.useState(0);

	const [Sessions, setSessions] = useState([])


	useEffect(() => {
		moment.loadPersian();

		const getSessions = async () => {
			try {
				const query = {
					page:page+1,
					per_page:rowsPerPage
				}
				const {data} = await makeRequest('getSessions', {},query)
				const sessions = data.sessions.docs
				setSessions(sessions)
				setTotalDocs(data.sessions.totalDocs)
			} catch (e) {
				console.log(e)
			}
		}

		getSessions()
	}, [page,rowsPerPage])

	function handleSelectAllClick(event) {
		if (event.target.checked) {
			const newSelecteds = Sessions.map(n => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	}

	function handleRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		setOrder(isDesc ? "asc" : "desc");
		setOrderBy(property);
	}


	function stableSort(array, cmp) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = cmp(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map(el => el[0]);
	}

	function desc(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getSorting(order, orderBy) {
		return order === "desc"
			? (a, b) => desc(a, b, orderBy)
			: (a, b) => -desc(a, b, orderBy);
	}

	const isSelected = name => selected.indexOf(name) !== -1;

	function handleClick(event, name) {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	}

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, Sessions.length - page * rowsPerPage);

	function handleChangePage(event, newPage) {
		setPage(newPage);
	}

	function handleChangeRowsPerPage(event) {
		setPage(0)
		setRowsPerPage(parseInt(event.target.value, 10));
	}

	return (
		<>
			<Paper className={"classes.paper"}>
				<div className={"tableWrapper"}>
					<Table
						className={"classes.table"}
						aria-labelledby="tableTitle"
						size={"medium"}
					>
						<EnhancedTableHead
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={Sessions.length}
							headRows={headRows}
						/>
						<TableBody>
							{stableSort(Sessions, getSorting(order, orderBy))
								.filter(q=>q.user)
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										<TableRow
											hover
											onClick={event => handleClick(event, row.id)}
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<TableCell padding="checkbox">
												<Checkbox
													checked={isItemSelected}
													inputProps={{
														"aria-labelledby": labelId
													}}
												/>
											</TableCell>
											<TableCell
												component="th"
												id={labelId}
												align="right"
											>
												{row.id}
											</TableCell>
											<TableCell align="right">{row.user.name}</TableCell>
											<TableCell align="right">{row.room.name}</TableCell>
											<TableCell align="right">{Math.round(row.ttl / 60)}</TableCell>
											<TableCell align="right">{moment.unix(row.expire_date).format("HH:mm jYYYY/jMM/jDD")}</TableCell>
											<TableCell align="right">{row.active ? t('Yes') : t('No')}</TableCell>
										</TableRow>
									);
								})}
							{/*{emptyRows > 0 && (
								<TableRow style={{height: 49 * emptyRows}}>
									<TableCell colSpan={6}/>
								</TableRow>
							)}*/}
						</TableBody>
					</Table>
				</div>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25, 50, 100]}
					component="div"
					labelRowsPerPage={t('NumberPerPage')}
					count={totalDocs}
					rowsPerPage={rowsPerPage}
					page={page}
					backIconButtonProps={{
						"aria-label": "Previous Page"
					}}
					nextIconButtonProps={{
						"aria-label": "Next Page"
					}}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</Paper>
		</>
	);
};;